'use client';

import Link from 'next/link';

export default function FinePrint() {
    return (
        <p className='is-size-8 eventTextColor'>
            *Réseau 5G : Déploiement progressif du réseau 5G (3,5 GHz et 2,1 GHz), principalement en zones urbaines avec
            offre et mobile compatibles 5G. Téléphones compatibles 5G et cartes de couverture sur{' '}
            <Link href='https://www.bouyguestelecom.fr/' target='_blank' rel='noopener noreferrer'>
                bouyguestelecom.fr
            </Link>
            .
        </p>
    );
}
